import { SEO_PAGES } from "./seo/pagesContent";

// Every public page of the site: one place for its path, <title>, meta
// description and page component. The prerender script, the sitemap and the
// client all read this list.

const seoPage = (pageId) => ({
  path: SEO_PAGES[pageId].path,
  page: "seo",
  pageId,
  title: SEO_PAGES[pageId].title,
  description: SEO_PAGES[pageId].description,
  localSections: ["contacto"], // these pages carry their own quote form
});

export const ROUTES = [
  {
    path: "/",
    page: "home",
    // Home title/description come from the locale files (meta.title / meta.description).
  },
  seoPage("delicias"),
  seoPage("chihuahua"),
  seoPage("seca"),
  seoPage("refrigerada"),
];

export const NOT_FOUND = {
  path: "/404.html",
  page: "notFound",
  title: "Página no encontrada | Transportes CGMG",
  description: "La página que busca no existe. Vuelva al inicio de Transportes CGMG.",
};

/** "/carga-seca" and "/carga-seca/" are the same page; "/" stays "/". */
export function normalizePath(pathname) {
  if (!pathname || pathname === "/" || pathname === "/index.html") return "/";
  const p = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return p.endsWith("/") ? p : `${p}/`;
}

export function findRoute(pathname) {
  const p = normalizePath(pathname);
  return ROUTES.find((r) => r.path === p) || NOT_FOUND;
}
